/*!
 * Copyright (c) 2026 GS Elektromedizinische Geraete G. Stemple GmbH, Germany - all rights reserved.
 * <p>
 * DO NOT ALTER OR REMOVE COPYRIGHT NOTICES OR THIS FILE HEADER.
 */

@use '../../../variables';
@use '../../../mixins';

$gap: variables.$gap-between-lists;

.acronym-wireframe {
  display: flex;
  flex-direction: column;
  row-gap: $gap;

  h2.acronym-section {
    margin-top: variables.$margin-xlarge;
    margin-bottom: variables.$margin-medium;
  }

  > div > div {
    display: flex;
    flex-direction: column;
    row-gap: $gap;
  }

  .field-row {
    @include mixins.page-grid-basics;
    grid-auto-columns: minmax(0, 1fr);
    grid-auto-flow: column;
    grid-template-rows: auto;
    margin-top: calc($gap / 2);
  }

  .error {
    font-weight: bold;
    background-color: variables.$color-corpuls-system-red-lightest;
    padding: variables.$padding-medium;
    border-radius: 20px;
    text-align: center;
  }

  .show-spaces {
    white-space: pre;
  }
}
